import RulesPerPANTableHandler from '@Modules/cardManagementSystem/smart/containers/tableHandlers/scriptProcessing/rules/perPAN/RulesPerPANTableHandler';
import RulesPerBINTableHandler from '@Modules/cardManagementSystem/smart/containers/tableHandlers/scriptProcessing/rules/perBIN/RulesPerBINTableHandler';
import { ChakraComponents as CC } from '@Modules/core/lib/chakra';


export default function ScriptProcessingParameters() {
  return (
    <>
      <CC.Box mb={10}>
        <CC.Text fontSize={20} fontWeight="bold" mb="4">
        Règles
        </CC.Text>
      </CC.Box>
      <CC.Tabs>
      <div style={{overflow: 'auto'}}>
        <CC.TabList>
          <CC.Tab minWidth={'fit-content'}>Par PAN</CC.Tab>
          <CC.Tab minWidth={'fit-content'}>Par BIN</CC.Tab>          
        </CC.TabList>
      </div>

      <CC.TabPanels>

        <CC.TabPanel>
          <RulesPerPANTableHandler />
        </CC.TabPanel>
        <CC.TabPanel>
          <RulesPerBINTableHandler />
        </CC.TabPanel>

      </CC.TabPanels>
    </CC.Tabs>
    </>
  );
  
}